module.exports = __webpack_public_path__ + "img/swiperNext.59e24721.svg";